
import { stoves } from '../config.js';
import { convertCoordinatesToWallBasedPositioning } from './stovePositionConverter';
import { lightType } from './enums';
import { element } from 'prop-types';
import localization from './localization';

let convertLigthingType = (lightning) => {
    let result = lightType.NoLigthing;
    if (lightning.benchLight) {
        if (lightning.roofLight) result = lightType.BenchWithRoof;
        else if (lightning.stoveLight) result = lightType.BenchWithStove + ";" + lightning.fibers;
        else result = lightType.Bench + ";" + lightning.fibers;
    }
    else if (lightning.roofLight) {
        if (lightning.stoveLight)
            result = lightType.RoofWithStove
        else
            result = lightType.Roof;
    }
    else if (lightning.linearLight) {
        if (lightning.stoveLight)
            result = lightType.LinearWithStove;
        else
            resul = lightType.Linear;
    }
    return result;
};

let getStoveExportId = (stoveid) => {
    return stoves.find(s => s.id === stoveid).exportID;
};


let loadFileAsync = (file) => {
    return new Promise((resolve, reject) => {
        var fr = new FileReader();
        fr.onload = () => {
            resolve(fr.result)
        };
        fr.onerror = () => reject("error loading file " + file);
        fr.readAsDataURL(file);
    });
}

let addAttachmentsFilesAsync = (requestObject, state) => {
    var files = [];

    state.contactDetails.attachments.forEach(file => files.push(file));
    state.measurements.floorImage.forEach(file => files.push(file));
    var fileLoadPromises = [];
    for (var i = 0; i < files.length; i++) {
        let file = files[i];
        fileLoadPromises.push(loadFileAsync(file).then((r) => {
            requestObject.Attachments.push({ Name: file.name, Contents: r });
        }));
    }
    return Promise.all(fileLoadPromises).then(() => requestObject);
}



let useCustomerFloorImage = (measurements) => {
    return measurements.positioningSkipped && measurements.floorImage.length == 1 && (measurements.floorImage[0].name.endsWith("png") || measurements.floorImage[0].name.endsWith("jpg"))
}


export default function (state) {

    let stovePosition = convertCoordinatesToWallBasedPositioning(state.measurements);
    let cadimage = undefined;
    if (state.plan.sent) {
        if (!useCustomerFloorImage(state.measurements)) {

            let canvas = document.querySelector(".konvajs-content canvas");
            if (canvas) cadimage = canvas.toDataURL("image/jpeg", 0.15);
        }
        else {
        }
    }       
    let doorSelection = buildDoorSelections(state)
    let result = {

        SecurityToken: state.plan.securityToken,
        SaunaWidth: !state.measurements.skipped ? parseInt(state.measurements.doorWallWidth, 10) || 0 : 0,
        SaunaDepth: !state.measurements.skipped ? parseInt(state.measurements.depth, 10) || 0 : 0,
        SaunaHeight: !state.measurements.skipped ? parseInt(state.measurements.height, 10) || 0 : 0,
        DoorWidth: !state.measurements.skipped ? parseInt(state.measurements.doorWidth, 10) || 0 : 0,
        DoorfromLeft: !state.measurements.skipped ? parseInt(state.measurements.doorFromLeft, 10) || 0 : 0,
        LeftSideGlassWidth: doorSelection.leftSideGlassWidth,
        LeftSideGlassHeight: doorSelection.leftSideGlassHeight,
        RigthSideGlassHeight: doorSelection.rigthSideGlassHeight,
        RightSideGlassWidth: doorSelection.rightSideGlassWidth,
        DoorHandness: doorSelection.doorHandness,
        DoorType: state.plan.hasDoor ? doorSelection.doorType : 2,
        GlassMaterial: state.measurements.glassMaterial,
        GlassListMaterial: state.measurements.glassListMaterial,
        HasUpperGlass: doorSelection.hasUpperGlass,
        UpperGlassHeight: doorSelection.upGlassHeight,
        DoorHeight: doorSelection.doorHeight,
        Stove: state.plan.hasStove ? getStoveExportId(state.benchModel.stove) : "Oma kiuas " + state.stove.stoveDescription,
        StoveFromLeft: parseInt(stovePosition.stoveFromLeft),
        StoveWall: stovePosition.stoveWall,
        LightningType: state.plan.hasLights ? state.saunaLighting.selectedLight?.id : lightType.NoLigthing,
        ResellerRequestsAssistance: state.plan.requestResellerAssistance,
        ResellerId: state.plan.resellerId,
        Address: {
            Name: state.contactDetails.name || "",
            City: state.contactDetails.city || "",
            Postal: state.contactDetails.postalNumber || "",
            Email: state.contactDetails.email || "",
            Phone: state.contactDetails.phone || "",
            Address: state.contactDetails.address || "",
            Country: state.contactDetails.country || ""
        },
        Sent: state.plan.sent,
        SellerReference: state.plan.sellerId,
        Rows: state.optionPricing.optionRows,
        Attachments: [],
        Project: {
            description: state.measurements.comment+" "+ state.contactDetails.notes 
        }   
    };
    if (state.plan.id)
        result.Id = state.plan.id;
    if (state.installProduct.installWanted === true) {
        result.Install = getInstall(state.installProduct)
    }

    if(state.plan.hasPaneling)
    {
         result.PanelDirection = (state.paneling.panelingDirection === "pysty") ? "Vertical" : "Horizontal";
         result.PanelMaterial =parseInt(state.paneling.panelMaterial, 10) || 0;
    }
    if(state.plan.hasBench)
    {
        result.BenchShape = state.benchModel.shape.code,
        result.BottomBenchUnderUpperBench = state.benchModel.model.bottomBenchUnderUpperBench,
        result.BenchBrand = state.benchModel.model.name.replace("relax XL","relax"),
        result.BenchComment = state.benchModel.model.name + " " + state.benchModel.shape.name,
        result.Mirrored = state.benchModel.shape.mirrored || state.benchModel.mirrored,
        result.BenchMaterial = parseInt(state.benchModel.material, 10),
        result.CurvedPieces = parseInt(state.benchModel.profileMaterial, 10),
        result.VImage = state.benchModel.code;
        result.CadImage = cadimage;        
    };
    return addAttachmentsFilesAsync(result, state);
}


let getInstall = (install) => {
        let result = {
            Description: install.comment
        };
        if (install.projectType === "newConstruction") {
            result.PlanType = 1
        }
        else if (install.projectType === "renovation") {
            result.PlanType = 2
        }
        result.SubJobs = install.categories.filter(j => j.selected === true).map(j => {
            return {
                Name: j.name,
                Id: j.id,
                Description: localization[j.localizationKey]
            };
        });
        if (install.estimatedDate)
            result.Date = install.estimatedDate
        return result;  
}


let buildDoorSelections = (state) => {
    let result =
    {
        leftSideGlassWidth: 0,
        leftSideGlassHeight: 0,
        rigthSideGlassHeight: 0,
        rightSideGlassWidth: 0,
        hasUpperGlass: false,
        doorType: 0
    }

    switch (state.measurements.doorType) {
        case "fullGlassWall":
            result.doorType = 1;
            if (state.measurements.doorFromLeft > mininmumSideGlassWidth) {
                result.leftSideGlassWidth = Math.round(state.measurements.doorFromLeft);
                result.leftSideGlassHeight = 1800;
            }
            if (state.measurements.doorWallWidth - state.measurements.doorWidth - state.measurements.doorFromLeft) {
                result.rightSideGlassWidth = Math.round(state.measurements.doorWallWidth - state.measurements.doorWidth - state.measurements.doorFromLeft);
                result.rigthSideGlassHeight = 1800;
            }
            break;
        case "halfGlassWall":
            result.doorType = 1;
            if (state.measurements.doorFromLeft > mininmumSideGlassWidth) {
                result.leftSideGlassWidth = Math.round(state.measurements.doorFromLeft);
                result.leftSideGlassHeight = 1000;
            }
            if (state.measurements.doorWallWidth - state.measurements.doorWidth - state.measurements.doorFromLeft) {
                result.rightSideGlassWidth = Math.round(state.measurements.doorWallWidth - state.measurements.doorWidth - state.measurements.doorFromLeft);
                result.rigthSideGlassHeight = 1000;
            }
            break;
        case "onlyGlassDoor":
            result.doorType = 1;
            break;
        case "customGlassWall":
            if (state.measurements.rightSideGlassEnabled) {
                result.rightSideGlassWidth = state.measurements.rightSideGlassWidth;
                result.rigthSideGlassHeight = state.measurements.rightSideGlassHeight;
            }
            if (state.measurements.leftSideGlassEnabled) {
                result.leftSideGlassWidth = state.measurements.leftSideGlassWidth;
                result.leftSideGlassHeight = state.measurements.leftSideGlassHeight;
            }
            result.doorType = 1;
            result.doorHandness = state.measurements.doorHandness == "left" ? 0 : 1;
            result.hasUpperGlass = state.measurements.upGlassEnabled;
            result.doorHeight = verifyInteger(state.measurements.doorHeight);
            result.upGlassHeight = verifyInteger(state.measurements.upGlassHeight);

            break;
        case "doorWithCarms":
            result.doorType = 3;
            break;
        case "ownDoor":
            result.doorType = 2;
    }
    result.leftSideGlassHeight = verifyInteger(result.leftSideGlassHeight);
    result.leftSideGlassWidth = verifyInteger(result.leftSideGlassWidth);
    result.rightSideGlassWidth = verifyInteger(result.rightSideGlassWidth);
    result.rigthSideGlassHeight = verifyInteger(result.rigthSideGlassHeight); 
    return result;
}

let verifyInteger = (value) => parseInt(value, 10) || 0;


let mininmumSideGlassWidth = 500;